let initialized = false;

function isMockSession() {
  if (typeof window === 'undefined') return false;
  try {
    if (window.location?.hash?.startsWith('#mock=')) return true;
    return !!window.localStorage.getItem('mockToken');
  } catch {
    return false;
  }
}

export function initAnalytics() {
  if (initialized || typeof window === 'undefined') return;
  if (isMockSession()) {
    console.info('[analytics] mock session detected — GA4/Pixel init skipped');
    initialized = true;
    return;
  }
  initialized = true;

  const ga4 = import.meta.env.VITE_GA4_ID;
  const pixel = import.meta.env.VITE_META_PIXEL_ID;

  if (ga4) {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', ga4, {
      anonymize_ip: true,
      transport_type: 'beacon',
      linker: {
        domains: ['cristianlessa.com.br', 'juros-abusivos.cristianlessa.com.br', 'cristianlessa.web.app', 'cristianlessa-landing.web.app'],
        accept_incoming: true,
      },
    });
  }

  if (pixel) {
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', pixel);
    window.fbq('track', 'PageView');
  }
}

export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined') return;
  if (isMockSession()) return;
  if (window.gtag) window.gtag('event', name, params);
  if (window.fbq) window.fbq('trackCustom', name, params);
}

export function trackPageView(path) {
  if (typeof window === 'undefined') return;
  if (isMockSession()) return;
  if (window.gtag) window.gtag('event', 'page_view', { page_path: path });
  if (window.fbq) window.fbq('track', 'PageView');
}
